"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getValue_1 = __importDefault(require("./getValue"));
var applyPatch_1 = __importDefault(require("./applyPatch"));
function randomId() {
    return (Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15));
}
function errPatch(db, path, obj) {
    var err = (0, getValue_1.default)(db.static, path);
    err.value = obj;
    err.id = path;
    err.refId = randomId();
    db.errors[err.refId] = err;
    (0, applyPatch_1.default)(db, [
        {
            op: "add",
            path: "/err/" + err.name + "/-",
            value: err,
        },
    ], true);
}
exports.default = errPatch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ZuL2Vyci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHdEQUE2QjtBQUM3Qiw0REFBc0M7QUFFdEMsU0FBUyxRQUFRO0lBQ2YsT0FBTyxDQUNMLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUM7UUFDM0MsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUM1QyxDQUFDO0FBQ0osQ0FBQztBQUVELFNBQVMsUUFBUSxDQUFDLEVBQUUsRUFBRSxJQUFJLEVBQUUsR0FBRztJQUM3QixJQUFJLEdBQUcsR0FBRyxJQUFBLGtCQUFHLEVBQUMsRUFBRSxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUMsQ0FBQztJQUUvQixHQUFHLENBQUMsS0FBSyxHQUFHLEdBQUcsQ0FBQztJQUNoQixHQUFHLENBQUMsRUFBRSxHQUFHLElBQUksQ0FBQztJQUNkLEdBQUcsQ0FBQyxLQUFLLEdBQUcsUUFBUSxFQUFFLENBQUM7SUFFdkIsRUFBRSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsR0FBRyxDQUFDO0lBRTNCLElBQUEsb0JBQVUsRUFDUixFQUFFLEVBQ0Y7UUFDRTtZQUNFLEVBQUUsRUFBRSxLQUFLO1lBQ1QsSUFBSSxFQUFFLFVBQVEsR0FBRyxDQUFDLElBQUksT0FBSTtZQUMxQixLQUFLLEVBQUUsR0FBRztTQUNYO0tBQ0YsRUFDRCxJQUFJLENBQ0wsQ0FBQztBQUNKLENBQUM7QUFFRCxrQkFBZSxRQUFRLENBQUMifQ==